"use client";

import Link from "@/components/ui/Link";
import type { ConsentChoice } from "@/lib/consent";
import { useUi } from "@/components/ui/use-ui";

/**
 * The cookie choice, for visitors where consent is required (lib/consent.ts): above the phone menu,
 * in the bottom corner on computers. Until they choose, partners' ads stay off.
 */
export function ConsentBanner({ onChoose }: { onChoose: (choice: ConsentChoice) => void }) {
  const t = useUi().consent;
  return (
    <div
      role="dialog"
      aria-label={t.title}
      data-consent
      className="glass fixed inset-x-2 bottom-[calc(max(0.5rem,env(safe-area-inset-bottom))+4rem)] z-40 rounded-2xl p-4 shadow-[0_20px_60px_-15px_rgb(0_0_0/0.9)] md:inset-x-auto md:bottom-5 md:right-5 md:max-w-[420px]"
    >
      <p className="text-[14px] font-medium text-fg">{t.title}</p>
      <p className="mt-1.5 text-[13px] leading-relaxed text-muted">
        {t.body}{" "}
        <Link href="/privacy" className="text-soft underline underline-offset-2 hover:text-fg">
          {t.privacy}
        </Link>
      </p>
      <div className="mt-3.5 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onChoose("all")}
          className="h-10 rounded-full bg-brand-strong px-5 text-[14px] font-medium text-white transition-colors hover:bg-brand-deep"
        >
          {t.acceptAll}
        </button>
        <button type="button" onClick={() => onChoose("essential")} className="chip h-10 rounded-full px-5 text-[14px] text-soft hover:text-fg">
          {t.onlyNecessary}
        </button>
      </div>
    </div>
  );
}
